import {userService} from "../services/UserService";

export function parseNameParcela(nombre: string): string {
    if (userService.getUser() === 'demo') {
        // if (nombre.toLowerCase() === 'casadelvalle-p2') return 'Vid-Merlot'
        // if (nombre.toLowerCase() === 'imidra-olivar') return 'Olivar-Experimental'
        // if (nombre.toLowerCase() === 'gdlc-intensivo') return 'Olivar-Intensivo'
        // if (nombre.toLowerCase() === 'gdlc-superintensivo') return 'Olivar-Superintensivo'
        // if (nombre.toLowerCase() === 'imidra-pistacho') return 'Pistacho-Experimental'
        return nombre
    } else {
        return nombre
    }
}
